import React, { useEffect, useRef } from 'react';

interface TwitterEmbedProps {
  url: string | undefined;
}

declare global {
  interface Window {
    twttr?: {
      widgets: {
        load: (element?: HTMLElement) => void;
      };
    };
  }
}

const TwitterEmbed: React.FC<TwitterEmbedProps> = ({ url }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const existingScript = document.querySelector('script[src*="platform.twitter.com"]');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://platform.twitter.com/widgets.js';
      script.async = true;
      script.charset = 'utf-8';

      script.onload = () => {
        if (window.twttr?.widgets && containerRef.current) {
          window.twttr.widgets.load(containerRef.current);
        }
      };

      document.body.appendChild(script);
    } else if (window.twttr?.widgets && containerRef.current) {
      window.twttr.widgets.load(containerRef.current);
    }
  }, [url]);

  if (!url) return null;

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <blockquote className="twitter-tweet" data-dnt="true">
        <a href={url}>Loading tweet...</a>
      </blockquote>
    </div>
  );
};

export default TwitterEmbed;
